<div class="container-narrow my-5">
  <app-visit-review-about-salon *ngIf="salonDetails && isTokenValid"
                                [salonDetails]="salonDetails">
  </app-visit-review-about-salon>

  <div class="row justify-content-center">
    <div class="col-12 col-sm-6">
      <div class="card border-0 shadow">
        <div class="card-body">
          <ng-container *ngIf="isTokenValid">
            <ng-container *ngIf="!formSubmitted">
              <p class="notranslate"
                 [translate]="'VISIT-REVIEWS.ADD.GREETING-TEXT'"
                 [translateParams]="{ salonName: salonDetails.name }"></p>
              <app-visit-review-add-form [visitReviewFormData]="visitReviewFormData"
                                         (formSubmitted)="ratingFormSubmitted()"></app-visit-review-add-form>
            </ng-container>

            <ng-container *ngIf="formSubmitted">
              <p [translate]="'VISIT-REVIEWS.ADD.SEND-SUCCESS.TITLE'"></p>
              <p [translate]="'VISIT-REVIEWS.ADD.SEND-SUCCESS.DESCRIPTION'">
              </p>
              <div class="text-end">
                <button type="button"
                        [translate]="'VISIT-REVIEWS.ADD.SEND-SUCCESS.BUTTON-GO-TO-SALON'"
                        (click)="goToSalonPage()"
                        class="btn btn-primary">
                </button>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!isTokenValid">
            <p class="mb-2"
               [translate]="'VISIT-REVIEWS.ADD.INVALID-TOKEN.DESCRIPTION'"></p>
            <p class="mb-0 fw-bold"
               [translate]="'VISIT-REVIEWS.ADD.INVALID-TOKEN.HINT'"></p>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>
